let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("15phN"), load("6Fw2s"), load("kkwHr")]).then(() => parcelRequire('7UEnN'));